import { lazy } from 'react';

const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

export const NotFoundEntry = () => <NotFoundPage />;
